import React from 'react';
import AmiraIconButton, { ICON_BUTTON_TYPES } from '../Global/AmiraIconButton2/AmiraIconButton2';

const INSTRUCTION_PHASE_SUBMIT_NOOP = () => {};

export default function BucketingSubmitButton({
  hideSubmit,
  pointerTarget,
  isInstruction,
  isRepeating,
  boardIsDirty,
  submitEnabled,
  onSubmit,
}) {
  return (
    <AmiraIconButton
      type={ICON_BUTTON_TYPES.SUBMIT}
      oblong
      onClick={
        isInstruction
          ? INSTRUCTION_PHASE_SUBMIT_NOOP
          : () => !isRepeating && submitEnabled && onSubmit()
      }
      disabled={isInstruction ? !boardIsDirty : !submitEnabled || isRepeating}
      invisible={hideSubmit}
      pointerPosition="left"
      showPointer={pointerTarget === 'submit'}
    />
  );
}
